import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-2">
        By using our Ride Booking App, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
      </p>
      <ul className="list-disc list-inside space-y-2">
        <li>You must provide accurate details including name, gender, home, and office location.</li>
        <li>Your use of the app must be lawful and respectful of other users.</li>
        <li>We reserve the right to suspend or terminate your access if you violate these terms.</li>
        <li>Ride schedules and pricing may vary and are subject to change.</li>
        <li>We are not liable for delays, cancellations, or incidents during the ride.</li>
      </ul>
    </div>
  );
};

export default TermsAndConditions;